<div class="attributes attributes--sources" [class.no-margin]="hasNoMargin()">
  @if (withHeading()) {
    <rt-heading variant="subheading">
      {{ 'app.common.sources' | translate }}
    </rt-heading>
  }
  <rt-attributes
    (query)="sourceTypeaheadUpdate($event)"
    (save)="saveSource.emit($event)"
    (delete)="deleteSource.emit($event)"
    (loadMore)="loadMoreSources($event)"
    [translationsContext]="'sources'"
    [canPick]="sources().editable!"
    [canRemove]="sources().editable!"
    [canCreate]="sources().writable!"
    [attributes]="sources().value!"
    [suggestionsData]="$any(sourcesTypeahead)"
    [hasMarginTop]="true"
    [hasTagsFontWeightMedium]="true"
    [hasSmallXXXMargins]="true"
    [selectHeaderTemplate]="sourcesHeaderTemplate"
    [tagsHoverable]="false"
    [tagsClickable]="false"
    [itemsLimit]="limitItems() ? displayLimit : undefined"
    [hasValueTooltipMinLength]="40"
  />
  @if (withEmptyState() && !sources().value?.length && !sources().editable!) {
    <rt-icon name="remove" colorToken="colorIconDisabled" />
  }

  <ng-template #sourcesHeaderTemplate>
    <rt-dropdown-header>
      {{ 'app.common.placeholders.search.sources.other' | translate }}
      <a
        rt-icon-button
        suffix
        iconName="settings"
        size="small"
        variant="plain"
        [routerLink]="['/settings/tags']"
        [queryParams]="{ tab: 'candidateSources' }"
      ></a>
    </rt-dropdown-header>
  </ng-template>
</div>
